import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { AccessRights } from '../../../environments/environment';
import { NotificationService } from '../../main/shared/notification.service';


enum Operation {
  View = 1,
  Add = 2,
  Edit = 4,
  Delete = 8,
  ViewAdd = 3,
  ViewEdit = 5,
  ViewDelete = 9,
  AddEdit = 6,
  AddDelete = 10,
  EditDelete = 12,
  ViewAddEdit = 7,
  ViewAddDelete = 11,
  ViewEditDelete = 13,
  AddEditDelete = 14,
  ViewAddEditDelete = 15
}


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  public accessRight = AccessRights;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private notifyservice: NotificationService
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    let url = state.url;
    const currentUser = this.authenticationService.currentUserValue;
     
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }
    if (currentUser != null) {
      
      //if (JSON.stringify(currentUser.menuList).indexOf(url) !== -1) {
      if (currentUser.menuList.filter(x => x.link === url).length > 0) {
        const userRights = this.authenticationService.currentUserRights(url);

        this.accessRight.isAdd = false;
        this.accessRight.isEdit = false;
        this.accessRight.isDelete = false;
        this.accessRight.isViewExport = false;

        if (userRights.permission == Operation.View) {
          this.accessRight.isViewExport = true;
        }
        else if (userRights.permission == Operation.Add) {
          this.accessRight.isAdd = true;
        }
        else if (userRights.permission == Operation.Edit) {
          this.accessRight.isEdit = true;
        }
        else if (userRights.permission == Operation.Delete) {
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.ViewAdd) {
          this.accessRight.isViewExport = true;
          this.accessRight.isAdd = true;
        }
        else if (userRights.permission == Operation.ViewEdit) {
          this.accessRight.isViewExport = true;
          this.accessRight.isEdit = true;
        }
        else if (userRights.permission == Operation.ViewDelete) {
          this.accessRight.isViewExport = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.AddEdit) {
          this.accessRight.isAdd = true;
          this.accessRight.isEdit = true;
        }
        else if (userRights.permission == Operation.AddDelete) {
          this.accessRight.isAdd = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.EditDelete) {
          this.accessRight.isEdit = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.ViewAddEdit) {
          this.accessRight.isViewExport = true;
          this.accessRight.isAdd = true;
          this.accessRight.isEdit = true;
        }
        else if (userRights.permission == Operation.ViewAddDelete) {
          this.accessRight.isViewExport = true;
          this.accessRight.isAdd = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.ViewEditDelete) {
          this.accessRight.isViewExport = true;
          this.accessRight.isEdit = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.AddEditDelete) {
          this.accessRight.isAdd = true;
          this.accessRight.isEdit = true;
          this.accessRight.isDelete = true;
        }
        else if (userRights.permission == Operation.ViewAddEditDelete) {
          this.accessRight.isViewExport = true;
          this.accessRight.isAdd = true;
          this.accessRight.isEdit = true;
          this.accessRight.isDelete = true;
        }

        // if (currentUser) {
        // logged in so return true
        return true;
      }

      // const landingPageMaster = JSON.parse(this.authenticationService.currentUserValue.landingpageInfo.data).filter(x => x.systemid == 'MASTER')[0].menuurl
      // let tempFilter = JSON.parse(this.authenticationService.currentUserValue.landingpageInfo.data).filter(x => x.systemid ==  'AfcsAdmin');
      // const landingPageProduct = tempFilter.length > 0 ? JSON.parse(this.authenticationService.currentUserValue.landingpageInfo.data).filter(x => x.systemid ==  'AfcsAdmin')[0].menuurl : '';


      // const landingPageMaster =  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
      // let tempFilter =  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
      // const landingPageProduct = tempFilter.length > 0 ?  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl : '';


      const landingPageMaster =  '/master/UserMaster'
      let tempFilter =  '/master/UserMaster'
      const landingPageProduct = tempFilter.length > 0 ?  '/master/UserMaster' : '';
      //If Landing Page : Vehicle Master is not assigned to user then logout
      if (url == landingPageMaster && this.authenticationService.currentUserValue.systemId == 'MASTER') {
        this.notifyservice.showWarning("Not authorized", "Page Access");
        this.authenticationService.logout();
        return false;
      }

      if (url == landingPageProduct && this.authenticationService.currentUserValue.systemId == 'AfcsAdmin') {
        this.notifyservice.showWarning("Not authorized", "Page Access");
        this.authenticationService.logout();
      
        return false;
      }

      if(url == '/auth/StartupPage')
      {
        return true;
      }

      //If page is not assigned to user then Logout
      //this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
      this.notifyservice.showWarning("Not authorized", "Page Access");
      this.authenticationService.logout();

      return false;
    }
    else {
      
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}

